module.exports = __webpack_public_path__ + "img/KSB.a0f9e03b.jpeg";